import React, {Component} from 'react'
import {Tabs, Tab, Grid} from 'react-bootstrap'
import PageTitle from '../../common/page-title'
import {history} from '../../../store';
import Carousel from './carousel'
import Tiles from './tiles'

class AdminHomePageMenu extends Component {
  constructor(props){
    super(props);

    let tab = this.props.location.hash;
    if(!tab){
      tab = 'tiles';
      history.replace(`/admin/homepage#${tab}`);
    } else {
      tab = tab.substr(1);
    }

    this.state = {tab};
  }

  handleTabSelect = (tab) => {
    history.replace(`/admin/homepage#${tab}`);
    this.setState({tab});
  };

  render(){
    return (
      <Grid bsClass="container" fluid className="homepagemenu">
        <PageTitle>Homepage</PageTitle>

        <Tabs activeKey={this.state.tab} onSelect={this.handleTabSelect} id="homePageMenuTab">
          <Tab eventKey="tiles" title="Edit Tiles">
						<Tiles/>
          </Tab>
          <Tab eventKey="carousel" title="Edit Carousel">
						<Carousel/>
          </Tab>
        </Tabs>
      </Grid>
    )
  }
}

export default AdminHomePageMenu



// WEBPACK FOOTER //
// ./src/components/admin/homepagemenu/index.jsx